"use strict";

var $         = require("jquery");            

/**
 * DOM utility class
 */
var DomUtil = {

    /**
     * Determine vendor specific css properties. 
     * This function create a div element, so it uses a lot of resources, result must be cached
     * @param  {String} prop "borderRadius" for exemple
     * @return {String}      return appropriate css property name
     */
    styleSupport:function ( prop ) {
        var vendorProp, supportedProp,

        // Capitalize first character of the prop to test vendor prefix
        capProp = prop.charAt( 0 ).toUpperCase() + prop.slice( 1 ),
        prefixes = [ "Moz", "Webkit", "O", "ms" ],
        div = document.createElement( "div" );

        if ( prop in div.style ) {
            // Browser supports standard CSS property name
            supportedProp = prop;
        }
        else {
            // Otherwise test support for vendor-prefixed property names
            for ( var i = 0; i < prefixes.length; i++ ) {
                vendorProp = prefixes[ i ] + capProp;
                if ( vendorProp in div.style ) {
                    supportedProp = vendorProp;
                    break;
                }
            }
        }

        // Avoid memory leak in IE
        div = null;

        return supportedProp;
    },

    /**
     * Determine which input events must be supported
     * @return {String} touch, pointer, or mouse
     */
    inputSupport:function () {
        var input;
        if("ontouchstart" in window){
            input="touch";
        }
        else if(window.navigator.pointerEnabled){
            input="pointer";            
        }
        else{
            input="mouse";
        }
        return input;
    },

    /**
     * Check if an element is partially visible in viewport
     * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
     * @param  {HTMLElement}  el 
     * @return {Boolean}    
     */
    isElementInViewport:function(el) {
        var rect = el.getBoundingClientRect();
        return !(
            rect.bottom <= 0 ||
            rect.top >= $(window).height()
        );
    },

    /**
     * check if current key down/up event occurs in an edit box like
     * @param  {Event}  e event fom keydow or keyup event
     * @return {Boolean}        [description]
     */
    isEditing:function(e){
        return (/input|textarea|select/i.test(e.target.nodeName) || e.target.contentEditable=="true");
    },

    /**
     * scroll to a position smoothly
     * @param  {Number} pos 
     */
    scrollTo:function(pos){
        $("html, body").animate({
            scrollTop: pos
        }, 500);
    },

    /**
     * Transforme duplique les events click en touchstart. C'est necessaire sur ipad car le système attends 400 ms 
     * avant de déclencher un click pour le différencier d'un drag ce qui donne une impression de lenteur
     * Attention a mettre un preventDefault dans la fonction pour ne pas avoir 2 events dans le cas où le device est à la fois tactile et souris
     * @param  {Object} events [description]
     * @return {Object}        [description]
     */
    clickToTouch:function(events){
        if(this.inputSupport()=="touch"){
            // transform click to touch events
            for (var key in events) {  
                if(key.indexOf("click")===0){  
                    var method=events[key];
                    var new_key=key.replace("click","touchstart");
                    events[new_key]=method;
                }
            }
        }
        return events;
    }

    
};

module.exports = DomUtil;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/common/utils/dom-util.js
// module id = 13
// module chunks = 0